import { FormattedMessage } from 'react-intl'
import { Text, View } from 'react-native'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import messages from '@flix/common/domain/video/messages'
import { Button } from '@flix/common/elements/controls'

const Layout = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

const Title = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.larger}px;
  text-align: center;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: ${(props) => props.theme.spacing.larger}px;
`

const Body = styled(Title)`
  max-width: 90%;
  font-weight: ${(props) => props.theme.fontWeights.normal};
  font-size: ${(props) => props.theme.fontSizes.medium}px;
  margin-bottom: ${(props) => props.theme.spacing.lg}px;
`

export const ForbiddenErrorPage = ({ onBack }) => {
  const history = useHistory()

  return (
    <Layout>
      <Title>
        <FormattedMessage {...messages.forbiddenTitle} />
      </Title>
      <Body>
        <FormattedMessage {...messages.forbiddenBody} />
      </Body>

      <Button intlMsg={messages.goBack} variant="primary" onPress={onBack ?? history.goBack} />
    </Layout>
  )
}
